'use strict'

var trimTrailingLines = require('trim-trailing-lines')

module.exports = root

// Root wrapper
function root(eat, value, silent) {
  var self = this

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  var now = eat.now()
  var subvalue = trimTrailingLines(value)

  return eat(subvalue)({
    type: 'root',
    children: self.tokenizeInline(subvalue, now)
  })
}
